import { useEffect, useState } from 'react'

const useIsMobile = (): boolean => {
  const [isMobile, setisMobile] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setisMobile(window.innerWidth < 1000)
      }

      handleResize()

      window.addEventListener('resize', handleResize)

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [])

  return isMobile
}

export default useIsMobile
